export const APP_CONFIG = {
  HONEYCOMB_SAMPLE_RATE: Number.parseInt(process.env.HONEYCOMB_SAMPLE_RATE ?? '80', 10),
}
